import React from 'react'
import ActivityItem from '../components/ActivityItem'
import { ActivityType } from '@/app/constants/activity'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { getActivityIcon } from '@/modules/drivers/helpers/ActivityIconResolver'
import { getActivityTypeNumber } from '@/app/services/activity/activityTypeResolver'
import { useActivity } from '@/modules/drivers/stores/activityStore'
import { FaIcon, faTruckRampCouchSolid } from '@/lib/fa'

const ACTIVITY_TYPES = [
  ActivityType.AVAILABILITY,
  ActivityType.WORK,
  ActivityType.DRIVING,
  ActivityType.REST,
  // ActivityType.UNKNOWN,
]

const ActivityTypes = () => {
  const { data, setData } = useActivity()
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-justify-between">
      <div className="tw-jusit tw-flex tw-flex-1 tw-items-start tw-gap-2 tw-font-medium tw-text-content-base">
        <FaIcon icon={faTruckRampCouchSolid} className='tw-max-w-[12px]' />
        <p className="tw-text-sm tw-font-semibold tw-text-content-base">
          {t('activities.activity-type')}
        </p>
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        {/* {ACTIVITY_TYPES.filter((a) => a !== ActivityType.UNKNOWN).map((a) => { */}
        {ACTIVITY_TYPES.map((a) => {
          return (
            <ActivityItem
              key={a}
              onClick={() =>
                setData({ ...data, activityType: getActivityTypeNumber(a) })
              }
              icon={getActivityIcon(getActivityTypeNumber(a))}
              label={t(`activityName.${a.toLocaleLowerCase()}`)}
              checked={getActivityTypeNumber(a) === data.activityType}
            />
          )
        })}
      </div>
    </div>
  )
}

export default ActivityTypes
